import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import SubmitCommentModal from '../../containers/submit-comment.jsx';

import {getPlatform} from '../../lib/platform';
import {back} from '../../lib/app/api';

import styles from './menu-bar-assistant.css';

import scratchLogo from './hetao-logo.png';
import backIcon from './icon--back.svg';
import TimingTips from '../timing-tips/timing-tips.jsx';

const MenuBarAssistant = props => (
    <Box className={styles.menuBar}>
        <div className={styles.mainMenu}>
            {getPlatform() === 'APP' ? <div
                className={classNames(styles.menuBarItem)}
                style={{marginLeft: '0'}}
                onClick={back()}
            >
                <Button iconSrc={backIcon} />
            </div> : null}
            <div
                className={classNames(styles.menuBarItem, styles.menuBarLogoItem)}
            >
                <img
                    alt="hetao"
                    className={styles.scratchLogo}
                    draggable={false}
                    src={scratchLogo}
                />
            </div>
            {
                props.isAnswer ? (
                    <div className={styles.answerTitle}>
                        {props.answerTitle}
                    </div>
                ) : (
                    <div className={styles.homeworkTitle}>
                        {props.homeworkTitle}
                    </div>
                )
            }
        </div>
        {
            !props.isAnswer &&
                <div className={styles.assistantToolBarContainer}>
                    <div className={styles.missionBtnContent}>
                        <div
                            className={classNames(styles.btnNext, {
                                [styles.btnDisable]: props.isListEmpty
                            })}
                            role="button"
                            tabIndex={0}
                            onClick={!props.isListEmpty && props.onClickNextItem}
                        >
                            {props.isListEmpty ? '最后一条' : '下一条'}
                        </div>
                        <div
                            className={classNames(styles.btnLookAtTheAnswer, {
                                [styles.btnDisable]: !props.answerUrl
                            })}
                            role="button"
                            tabIndex={0}
                            onClick={props.answerUrl && props.onClickAnswer}
                        >
                            {'查看答案'}
                        </div>
                    </div>
                    <div
                        className={styles.btnSubmitComment}
                        role="button"
                        tabIndex={0}
                        onClick={props.onOpenSubmitCommentModal}
                    >
                        {props.homeworkCorrected ? '再次点评' : '点评'}
                    </div>
                </div>
        }
        {props.submitCommentModalVisible ? (
            <SubmitCommentModal
                homeworkId={props.homeworkId}
                isTutor={props.isTutor}
                lessonId={props.lessonId}
            />
        ) : null}
        {props.homeworkLoaded && props.showTips ? (
            <TimingTips
                duration={2}
                tips={'学生已重新提交，请再次查看'}
                onHideTips={props.onHideTips}
            />
        ) : null}
    </Box>
);

MenuBarAssistant.propTypes = {
    answerTitle: PropTypes.string,
    answerUrl: PropTypes.string,
    homeworkCorrected: PropTypes.bool,
    homeworkId: PropTypes.number,
    homeworkLoaded: PropTypes.bool,
    homeworkTitle: PropTypes.string,
    isAnswer: PropTypes.string,
    isListEmpty: PropTypes.bool,
    isTutor: PropTypes.bool,
    lessonId: PropTypes.number,
    onClickAnswer: PropTypes.func,
    onClickNextItem: PropTypes.func,
    onHideTips: PropTypes.func,
    onOpenSubmitCommentModal: PropTypes.func,
    showTips: PropTypes.bool,
    submitCommentModalVisible: PropTypes.bool
};

const mapStateToProps = state => ({
    homeworkCorrected: state.scratchGui.assistant.homeworkCorrected,
    submitCommentModalVisible: state.scratchGui.modals.submitCommentModal,
    homeworkLoaded: Object.keys(state.scratchGui.targets.stage).length > 0
});

export default injectIntl(connect(
    mapStateToProps
)(MenuBarAssistant));
